import InterviewNote from './InterviewNote.container';

export default InterviewNote;
